module.exports = __webpack_public_path__ + "static/img/turntable2.f31dfb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/turntable2.png
// module id = QcMe
// module chunks = 88